module.exports = {
  "version": "0.27.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/sendbird/~/axios/lib/env/data.js
// module id = 565
// module chunks = 42